import PageProtected from "../../../components/Page/PageProtected";
import SectionDashboard from "../../../components/Section/SectionDashboard";

import SectionMonitoring from "./SectionMonitoring/SectionMonitoring";
import SectionGeneticsCvd from "./SectionGenetics/SectionGeneticsCvd";
import SectionMicrobiome from "./SectionMicrobiome/SectionMicrobiome";

import { useTheme } from "@mui/material";

export default function CvdWelcome() {

    const theme = useTheme();

return (
<>
    


    <PageProtected
    
    headline="CARDIOVASCULAR HEALTH - " 
    specify ="COCKPIT"

    main={<> 

    {theme.palette.mode === "light" ? (

        <SectionDashboard

            colorContainer="transparent"

            colorSection_1="grey.C300"
            Section_1={<SectionMonitoring />}

            colorSection_2="grey.C500"
            Section_2={ <SectionGeneticsCvd /> }
            
            colorSection_3="grey.C200"
            Section_3= { <SectionMicrobiome />} 

            colorSection_4="primary.C200"
            Section_4={ "" }

        />

):(

    <SectionDashboard

            colorContainer="transparent"

            colorSection_1="secondarydark.C100"
            Section_1={<SectionMonitoring /> }

            colorSection_2="secondarydark.C200"
            Section_2={ <SectionGeneticsCvd />}

            colorSection_3="secondarydark.C100"
            Section_3= {  <SectionMicrobiome /> } 

            colorSection_4="secondarydark.C200"
            Section_4={ "" }

        />
        )}
    </>
    
    }
/>

</>
)
}